import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { DialogSize } from './constants';

interface IDialogContextValue {
  isVisible: boolean;
  isSelfClosingDisabled: boolean;
  size: DialogSize;
  onClose: () => void;
}

const initialValue: IDialogContextValue = {
  isVisible: false,
  isSelfClosingDisabled: false,
  size: DialogSize.SMALL,
  onClose: () => {},
};

const DialogContext = createContext<IDialogContextValue>(initialValue);

export const useDialogContext = () => {
  return useContext(DialogContext);
};

interface IDialogContextProviderProps {
  isVisible: boolean;
  isSelfClosingDisabled: boolean;
  size: DialogSize;
  onClose: () => void;
}

export const DialogContextProvider = ({
  isVisible,
  isSelfClosingDisabled,
  size,
  onClose,
  children,
}: PropsWithChildren<IDialogContextProviderProps>) => {
  const value = useMemo(() => {
    return {
      isVisible,
      isSelfClosingDisabled,
      size,
      onClose,
    };
  }, [isVisible, isSelfClosingDisabled, size]);

  return (
    <DialogContext.Provider value={value}>
      {children}
    </DialogContext.Provider>
  );
};
